import { IUser } from '@my-backoffice/app/pages/user/shared/models/interfaces/user.interface';
import { AUTHENTICATION_SERVICE } from '@my-backoffice/app/shared/auth/authentication.token';
import { SERVER_URL } from '@my-backoffice/app/shared/constants/app.constants';
import { EStorageKeys } from '@my-backoffice/app/shared/models/enums/storage-keys.enum';
import { HttpResponseBodyNullableType } from '@my-backoffice/app/shared/models/interfaces/http-response-body.interface';
import { StorageService } from '@my-backoffice/app/shared/services/storage-services/storage.service';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _authenticationService = inject(AUTHENTICATION_SERVICE);

  public constructor(
    private readonly _httpClient: HttpClient,
    private readonly _storageService: StorageService
  ) {}

  public getUserById$(userId: string, isRefresh?: boolean): Observable<HttpResponseBodyNullableType<IUser>> {
    let url = `${SERVER_URL}/user/v2/${userId}`;

    if (isRefresh) {
      url += '?refresh=true';
    }

    return this._httpClient
      .get<HttpResponseBodyNullableType<IUser>>(url, { observe: 'body' })
      .pipe(map((response: Readonly<HttpResponseBodyNullableType<IUser>>): HttpResponseBodyNullableType<IUser> => response));
  }

  public updateUserDataSession(userData: IUser): void {
    this._authenticationService.updateUserData(userData);
    this._storageService.setItem(EStorageKeys.USER_DATA, JSON.stringify(userData));
  }

  public watchUserDataRefresh$(): Observable<HttpResponseBodyNullableType<IUser>> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);

    return this.getUserById$(userId, true).pipe(
      tap({
        next: (userData: HttpResponseBodyNullableType<IUser>): void => {
          if (userData?.content) {
            this.updateUserDataSession(userData.content);
          }
        },
      })
    );
  }
}
